module.exports = __webpack_public_path__ + "static/project3-41ac03fbc09b62393586c005331103c6.jpg";